( function ( $ ) {
	'use strict';

	const $gdprBanner = $( '.gdpr-banner' ),
		$bannerHeight = $gdprBanner.innerHeight(),
		$gdprButton = $( '.gdpr-banner__button' ),
		gdprStatus = localStorage.getItem( 'gdpr-status' );

	/* Set Default localStorage if not available */
	if( 'acknowledged' !== gdprStatus ) {

		/* Show Banner */
		$gdprBanner.show();

	}

	$gdprButton.on( 'click', function() {

		/* Set Local Storage */
		localStorage.setItem( 'gdpr-status', 'acknowledged' );

		/* Hide Banner */
		$gdprBanner.addClass( 'hidden' ).animate( {
			bottom: '-' + $bannerHeight + 1
		}, 300 );

	} );

} )( jQuery );
